import { SESSION_USER_CLAIMS, useItinInfo } from '@eventr/common'
import { devtools, persist, subscribeWithSelector } from 'zustand/middleware'
import { DEVTOOLS_ENABLED } from '../../consts'
import { DataAPI } from '../../data/Data'
import { bs, useBoundStore } from '../../state/bound.store'
import { IItinerary } from '../../state/interfaces'
import { getTimezoneOfItinerary } from '../../utils'
import { create } from '../appState/resetState'
import { logEvent } from '../firebase/firebase'

interface IGuestStore {
    guestData: {
        itinerary: IItinerary
        map_entry: any
        guest_token: string
        org_config: {
            activityCategories: any
        }
    } | null
    resolveGuestData: (data: any) => Promise<void>
    guestCode: string
    isGuestMode: boolean
    cloneOnSignUp: boolean
    setCloneOnSignUp: (cloneOnSignUp: boolean) => void
}

export const useGuestStore = create<IGuestStore>()(
    subscribeWithSelector(
        persist(
            devtools(
                (set, get) => ({
                    guestData: null,
                    guestCode: '',
                    isGuestMode: false,
                    cloneOnSignUp: false,
                    setCloneOnSignUp: (cloneOnSignUp) => {
                        set({ cloneOnSignUp }, false, 'setCloneOnSignUp')
                    },
                    resolveGuestData: async (guestCode) => {
                        logEvent('guest_resolve', { code: guestCode })
                        const guestData = await DataAPI.guest.getGuestData(
                            guestCode
                        )

                        bs().setItineraryMap([guestData.data.map_entry])
                        localStorage.removeItem(SESSION_USER_CLAIMS)
                        useBoundStore.setState({
                            chatEnabled: false,
                            teamPageEnabled: false,
                        })
                        await bs().setCurrentItin(
                            guestData.data.map_entry?.id ?? -1
                        )
                        bs().setSelectedOrg({ name: '__guest__' })
                        if (guestData.data.org_config)
                            bs().setOrgConfig(guestData.data.org_config)
                        useItinInfo
                            .getState()
                            .setTimezone(
                                getTimezoneOfItinerary(guestData.data.itinerary)
                            )
                        set(
                            {
                                guestData: guestData.data,
                                guestCode: guestCode,
                                isGuestMode: true,
                            },
                            false,
                            'resolveGuestData'
                        )
                        bs().pullEventData(guestData.data.map_entry?.id ?? -1)
                    },
                }),
                {
                    name: 'guest-store',
                    enabled: DEVTOOLS_ENABLED,
                }
            ),
            {
                name: 'guest-store',
            }
        )
    )
)
